import logo from "../../../img/renaissance-new/ppa-logo-icon.svg";
import mazeWithout from "../../../img/renaissance-new/maze-without-mentorship.svg";
import { WITHOUT_MENTORSHIP_POINTS, WITH_MENTORSHIP_POINTS } from "./mazeData";
import AnimatedMaze from "./AnimatedMaze";

const WarningIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="shrink-0">
        <path
            d="M8.57 3.33L1.85 15a1.67 1.67 0 001.44 2.5h13.42a1.67 1.67 0 001.44-2.5L11.43 3.33a1.67 1.67 0 00-2.86 0z"
            stroke="#DC2626"
            strokeWidth="1.4"
            strokeLinejoin="round"
        />
        <path d="M10 8.33V11" stroke="#DC2626" strokeWidth="1.4" strokeLinecap="round" />
        <circle cx="10" cy="13.75" r="0.9" fill="#DC2626" />
    </svg>
);

const CheckIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="shrink-0">
        <rect x="1" y="1" width="18" height="18" rx="4" fill="#10B981" />
        <path
            d="M5.5 10.2l2.7 2.7 6-6.4"
            stroke="white"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const ExpertGuidanceSection = () => {
    return (
        <div className="bg-white flex flex-col items-center px-5 py-10 md:px-[160px] md:py-[60px] gap-10">
            <p className="font-gilroy-bold text-[24px] leading-8 md:text-[40px] md:leading-[52px] tracking-[0.04em] text-black text-center max-w-[563px]">
                How Does Expert Guidance Accelerate Your Growth?
            </p>

            <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-10 md:gap-20 w-full max-w-[1120px]">
                <div className="flex flex-col items-center gap-6 w-full max-w-[520px]">
                    <div className="bg-white border border-black rounded-full px-5 py-2 font-gilroy-bold text-[16px] leading-6 md:text-[20px] md:leading-7 tracking-[0.02em] text-[#64748B]">
                        WITHOUT MENTORSHIP
                    </div>

                    <img src={mazeWithout} alt="Without mentorship maze" className="w-full h-auto max-w-[337px]" />

                    <div className="bg-[#FEE2E2] rounded-xl p-3 w-full grid grid-cols-2 gap-x-3">
                        {[0, 1].map((col) => (
                            <div key={col} className="flex flex-col gap-3">
                                {WITHOUT_MENTORSHIP_POINTS.map((pair, i) => (
                                    <div key={i} className="flex items-start gap-2">
                                        <WarningIcon />
                                        <p className="font-gilroy-regular text-[14px] md:text-[16px] leading-6 tracking-[0.02em] text-black">
                                            {pair[col]}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="hidden md:block w-px self-stretch bg-[#CBD5E1]" />

                <div className="flex flex-col items-center gap-6 w-full max-w-[520px]">
                    <div className="bg-[#3940A0] border border-black rounded-full pl-2 pr-5 py-2 flex items-center gap-2 font-gilroy-bold text-[16px] leading-6 md:text-[20px] md:leading-7 tracking-[0.02em] text-[#F8FAFC]">
                        <img src={logo} alt="" className="w-8 h-8" />
                        WITH MENTORSHIP
                    </div>

                    <AnimatedMaze />

                    <div className="bg-[#D1FAE5] rounded-xl p-3 w-full grid grid-cols-2 gap-x-3">
                        {[0, 1].map((col) => (
                            <div key={col} className="flex flex-col gap-3">
                                {WITH_MENTORSHIP_POINTS.map((pair, i) => (
                                    <div key={i} className="flex items-start gap-2">
                                        <CheckIcon />
                                        <p className="font-gilroy-regular text-[14px] md:text-[16px] leading-6 tracking-[0.02em] text-black">
                                            {pair[col]}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpertGuidanceSection;
